/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import dayjs from "dayjs";
import React, { useState } from "react";
import DateTimePicker from "../../DateTimePicker";
import StyledButton from "../../StyledButton";
import { useModal } from "../Modal";

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #eceeee;
  box-sizing: inherit;
  margin: 20px -22px 0px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const Buttons = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eceeee;
  padding: 20px 20px 0px;
`;

const InputLabel = styled.div`
  display: flex;
  flex-direction: column;
  width: 370px;
  margin-top: 20px;
  padding: 0px 20px;
`;

const Title = styled.div`
  color: #2f2f2f;
  font-weight: 400;
  margin-bottom: 5px;
`;

const ContButton = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
`;

interface Props {
  handleSave: (from: Date, to: Date) => void;
}

export default function DateRange(props: Props): JSX.Element {
  const modal = useModal();
  const [from, setFrom] = useState<Date>();
  const [to, setTo] = useState<Date>();
  const [calendarKeyFrom, setCalendarKeyFrom] = useState<string>("");
  const [calendarKeyTo, setCalendarKeyTo] = useState<string>("");

  return (
    <ModalBody>
      <Wrapper>
        <InputLabel>
          <Title>From</Title>
          <DateTimePicker
            date={from}
            onDateSelect={(date) => {
              setFrom(dayjs(date).startOf("day").toDate());
            }}
            onTimeSelect={() => {}}
            calendarKey={calendarKeyFrom}
            setCalendarKey={setCalendarKeyFrom}
            minDate={new Date("1997-04-01")}
            showDatePicker
            input
            hideFavorites
            hideTodayButton
          />
        </InputLabel>

        <InputLabel>
          <Title>To</Title>
          <DateTimePicker
            date={to}
            onDateSelect={(date) => {
              setTo(dayjs(date).endOf("day").toDate());
            }}
            onTimeSelect={() => {}}
            calendarKey={calendarKeyTo}
            setCalendarKey={setCalendarKeyTo}
            minDate={dayjs(from).add(1, "day").toDate()}
            disabled={!from}
            showDatePicker
            input
            hideFavorites
            hideTodayButton
          />
        </InputLabel>
      </Wrapper>

      <Buttons>
        <StyledButton
          inverted
          css={css`
            width: 80px;
            margin-right: 10px;
          `}
          onClick={() => {
            setCalendarKeyFrom("");
            setCalendarKeyTo("");
            setFrom(null);
            setTo(null);
          }}
        >
          Clear
        </StyledButton>

        <ContButton>
          <StyledButton
            inverted
            css={css`
              width: 80px;
              margin-right: 10px;
            `}
            onClick={() => modal.popModal()}
          >
            Cancel
          </StyledButton>
          <StyledButton
            css={css`
              width: 80px;
            `}
            onClick={() => {
              props.handleSave(from, to);
              modal.popModal();
            }}
            disable={!(from && to)}
          >
            Filter
          </StyledButton>
        </ContButton>
      </Buttons>
    </ModalBody>
  );
}
